import { styles as componentStyles } from './view.scss';
import { styles as helperStyles } from '../../../../../../assets/style-helpers.scss';
import { styles as commonStyles } from '../../../../../../assets/common.scss';
import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${componentStyles}`), unsafeCSS(`${helperStyles}`), unsafeCSS(`${commonStyles}`)];
